import { render, staticRenderFns } from "./Pautas.vue?vue&type=template&id=916d3640"
import script from "./Pautas.vue?vue&type=script&lang=js"
export * from "./Pautas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports